import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { LicenseAssignToAdmin } from 'mbs-ui-shared@models/License';
import { PermissionFlags } from 'mbs-ui-shared@models/PermissionFlags';

export type LicensesState = {
  permissionFlags: PermissionFlags;
  permissionFlagsLoaded: boolean;

  loadingBalance: boolean;
  balance: Balance;

  actionsInLoading: number;

  assignedLicense: LicenseAssignToAdmin;

  subscriptionEditLink: string;
  loadingSubscriptionEditLink: boolean;

  isInvalidLicenses: boolean;
};

export const initialLicensesState: LicensesState = {
  permissionFlags: null,
  permissionFlagsLoaded: false,

  loadingBalance: false,
  balance: null,

  actionsInLoading: 0,

  isInvalidLicenses: false,

  assignedLicense: null,

  subscriptionEditLink: null,
  loadingSubscriptionEditLink: false
};
